import { push } from 'immutadot/array';
import { set, unset } from 'immutadot/core';

import { get } from 'immutadot';
import {deepCopy} from "../utils";
export function isObject(obj) {
    return obj === Object(obj);
}

// converts [{id:1,name:'fred'},{id:21,name:'bert'}] into {1:'fred',21:'bert} for simplicity
function convertArrayToObject(array) {
    if (array == null) { array = []; }
    if (!Array.isArray(array)) return array;
    const object = {};
    array.forEach((v) => {
        object[v.id] = v;
    });
    return object;
}


// work out a path to an object, suitable for immutable's SET() command


function getAbsolutePath(object:any, path:string|string[], allowNew = false) {
    // allow a single creation, not a double
    const parts = Array.isArray(path) ? path : path.split('.');
    let currentValue = object;
    const newPath:string[] = [];
    let noPath = false;
    let noArrayItem = false;
    parts.forEach((pathPart) => {
        if (currentValue == null) {
            noPath = true;
            newPath.push('.' + pathPart);
            return;
        }
        if (Array.isArray(currentValue)) {
            let newReturnValue = null;
            let idx:number|null = null;
            currentValue.forEach((v, k) => {
                if (v.id == pathPart) {
                    newReturnValue = v;
                    idx = k;
                }
            });
            if (newReturnValue) {
                newPath.push('[' + idx + ']');
            } else {
                noArrayItem = true;
                noPath = true;
            }
            currentValue = newReturnValue;
            return;
        }
        if (isObject(currentValue)) {
            if (currentValue[pathPart]) {
                newPath.push('.' + pathPart);
                currentValue = currentValue[pathPart];
            } else {
                if (allowNew) {
                    newPath.push('.' + pathPart);
                    currentValue = null;
                }
            }
            return;
        }
        noPath = true;
        newPath.push('.' + pathPart);
        currentValue = currentValue[pathPart] ?? null;
        return;
    });
    if (noPath && !allowNew) return null;
    if (noArrayItem && allowNew) return null;
    const rv = newPath.join('');
    if (rv[0] == '.') { return rv.substring(1); }
    return rv;
}

type IterateObjectsCallbackProps = {
    key: string[],
    objects: unknown[],
    isArray: boolean,
    isObject?: boolean
}

type IterateObjectsCallback = (props: IterateObjectsCallbackProps) => boolean;

// iterate through the object tree, preserving path and calling toCall on all items
export const iterateObjects = (object1: any, object2: any, toCall: IterateObjectsCallback, prefix:string[] = []): void => {
    // these are leaves
    if (['string', 'number', 'boolean', 'bigint'].indexOf(typeof object1) > -1 || ['string', 'number', 'boolean', 'bigint'].indexOf(typeof object2) > -1) {
        toCall({ key: prefix, objects: [object1, object2], isArray: false, isObject: false });
        return;
    }
    // pseudo-objects we do not descend
    if (object1 instanceof File || object1 instanceof Blob || object2 instanceof File || object2 instanceof Blob) {
        toCall({ key: prefix, objects: [object1, object2], isArray: false });
        return;
    }
    if (object1 == null) {
        object1 = {};
    }
    if (object2 == null) {
        object2 = {};
    }
    const isArray = Array.isArray(object1) || Array.isArray(object2);
    let forcedObj1:object;
    let forcedObj2:object;
    if (isArray) {
        forcedObj1 = convertArrayToObject(object1);
        forcedObj2 = convertArrayToObject(object2);
    } else {
        forcedObj1 = object1;
        forcedObj2 = object2;
    }

    // compare every property that exists in either object
    let keys = Object.keys(forcedObj1).concat(Object.keys(forcedObj2));
    // remove dups
    keys = keys.filter((item, pos) => keys.indexOf(item) === pos);
    keys.forEach((key:string) => {
        const o1 = forcedObj1[key] ?? null, o2 = forcedObj2[key] ?? null;
        const descend = toCall({ key: prefix.concat(key), objects: [o1, o2], isArray: isArray });
        if (!descend) {
            return;
        }
        iterateObjects(o1, o2, toCall, prefix.concat([key]));
    });
}

// not immutable safe!!
// finds everything with a creation_id, records it and then deletes the creation_id
export const extractCreationIds = (object1: unknown): unknown => {
    const creationIds = [];
    iterateObjects(object1, {}, ({ key: names, objects: objects, isArray: isArray }) => {
        console.log('kiterate',names,objects,isArray);
        if (Array.isArray(objects[0])) {
            return true;
        }
        const o1 = objects[0];
        if (o1 == null) return false;
        if (typeof o1 != 'object') {
            return false;
        }
        if(o1.creation_id) {
            // the new value is always the ID
            //const origName = (isArray ? o1.id : names.pop());
            // if it's an array we use the ID for the index, otherwise use the attribute name
            let idPath = [],newIdPath = [];
            if(isArray) {
                idPath = [...names];
                idPath.pop();
                    idPath =  idPath.concat(o1.creation_id);
                newIdPath = [...names];
                newIdPath.pop();
                newIdPath = newIdPath.concat(o1.id);
//                    idPath.join('.');
//                idPath.pop();
//                idPath.push(o1.id);
            } else {
                idPath = names;
                newIdPath = names;
            }
            creationIds.push({ newId: o1.id, newIdPath: newIdPath.join('.'), oldIdPath: idPath.join('.') });
        }
        return true;
    });
    return creationIds;
}


// remove all the creationIds from the object tree
export const purgeCreationIds = (object1, creationIds: unknown): unknown => {
    creationIds.forEach((paths) => {
        const directPath = getAbsolutePath(object1, paths.newIdPath);
        console.warn('paths are',paths,directPath,object1);
        object1 = unset(object1, directPath+ '.creation_id');
    });
    return object1;
};

// rename any record that needs to be renamed according to creation_ids
export const applyCreationIds = (object1, creationIds: unknown): unknown => {
    creationIds.forEach((paths) => {
        const path = getAbsolutePath(object1, paths.oldIdPath);
        if (!path) return;
        object1 = set(object1, path + '.id', paths.newId);
    });
    return object1;
};

type ObjectDiff = {
    type:string,
    name:string[],
    isArray:boolean,
    value?:string|object|number|null|unknown
};


// generate a quick diff of 2 objects
export const diffObjects = (object1: unknown, object2: unknown): ObjectDiff[] => {
    const results:ObjectDiff[] = [];
    iterateObjects(object1, object2, ({ key: name, objects: [o1, o2], isArray: isArray }) => {
        if (o1 && o2 == null) {
            results.push({
                type:'D', 
                name:name,
                isArray:isArray
            });
            return false;
        }
        if (o2 && o1 == null) {
            if (typeof (o2) == 'object') {
                console.log('diffs are cloned',o2);
                if(Array.isArray(o2)) {
                    let val = null;
                    try {
                        val = o2.map((v)=>(deepCopy(v)));
                    } catch(e) {
                        val = [...o2];
                    }
                    results.push({
                        type:'A',name:name,isArray:isArray,value:val});
                } else {
                    let val = null;
                    try {
                        val = deepCopy(o2);
                    } catch(e) {
                        val = o2;
                    }
                    console.log('value is',val);
                    results.push({type:'A', name, isArray,value:val});
                }
            } else {
                results.push({type:'A', name, isArray,value: o2});
            }
            return false;
        }
        if (['string', 'number', 'boolean', 'bigint'].indexOf(typeof o1) > -1 || ['string', 'number', 'boolean', 'bigint'].indexOf(typeof o2) > -1) {
            if (o1 != o2) {
                results.push({type:'E', name, isArray, value:o2});
            }
            return false;
        }
        if (typeof (o2) == 'object' && typeof (o1) == 'object' && o1 && o2 && o1.id != o2.id) {
            let val = null;
            try {
                val = deepCopy(o2);
            } catch(e) {
                val = o2;
            }
            results.push({type:'E', name, isArray, value:val});
            return false;
        }
        return true;
    });
    return results;
}


export const applyDiffs = (targetObject: unknown, diffs: ObjectDiff[]): unknown => {
    console.log('id-diff:APPLY', diffs, targetObject);
    // try to apply every change in diffs to targetObject
    diffs.forEach((diff) => {
        if (diff.isArray && diff.type == 'A') {
            // if the child node already exists, ignore the change
            let targetPath = getAbsolutePath(targetObject, diff.name);
            console.log('id-diff apply to Array', {target:targetObject, path:targetPath, source:diff.value});
            // this may or may not be correct
            if (!targetPath) {

                // for an array insertion, we only want the parent node
                diff.name.pop();
                targetPath = getAbsolutePath(targetObject, diff.name);
                console.log('id-diff:targetPath', targetPath, diff.name);
                if (!targetPath) return;
                console.log('id-diff:PUSH', targetObject, targetPath, diff.value);
                targetObject = push(targetObject, targetPath, diff.value);
                return;
            }
        }
        const targetPath = getAbsolutePath(targetObject, diff.name, diff.type == 'A'||diff.type=='E'||diff.type=='D');
        if (!targetPath) return;
        if (diff.isArray) {
            console.log('id-diff:DELETE', get(targetObject, targetPath));
            switch (diff.type) {
                case 'D':
                    targetObject = unset(targetObject, targetPath);
                    break;
                /*                case 'A':
                                case 'E':
                                    console.log('diffs SET',{object:targetObject,diff:diff,path:targetPath,value:diff[3]});
                                    targetObject = set(targetObject, targetPath, diff[3]);
                                break;*/
            }
            console.log('id-diff:POST-DELETE', get(targetObject, targetPath));
            return;
        }
        switch (diff.type) {
            case 'A':
            case 'E':
                console.log('id-diff:SET', { object: targetObject.a, diff: diff, path: targetPath, value: diff.value });
                targetObject = set(targetObject, targetPath, diff.value);
                break;
            case 'D':
                console.log('id-diff:DELETEB', { object: targetObject.a, diff: diff, path: targetPath, value: diff.value });
                targetObject = unset(targetObject, targetPath);
                break;
        }
    });
    console.log('id-diff:Applied, returning', targetObject);
    return targetObject;
}